import syllabusIcon from "common/assets/font-awesome/book-open-solid.svg";
import folderIcon from "common/assets/font-awesome/folder.svg";
import studyProgrammeIcon from "common/assets/font-awesome/graduation-cap.svg";
import kurssloeyfeIcon from "common/assets/font-awesome/kurssloeyfe.svg";
import { default as multiplechoiceIcon } from "common/assets/font-awesome/question.svg";
import selfAssessmentsContainerIcon from "common/assets/font-awesome/self-assessments-folder.svg";
import articleIcon from "common/assets/font-awesome/text.svg";
import selfAssessmentIcon from "common/assets/font-awesome/user-check.svg";
import {
  BooksIcon,
  FolderIcon,
  MedalIcon,
  QuestionIcon,
  SelfAssessmentIcon,
  SyllabusIcon,
  TextIcon,
  VideoIcon,
} from "common/assets/icons/";
import { ContentInList } from "common/hooks/useBreadcrumbs";
import gql from "graphql-tag";
import * as React from "react";
import {
  ContentBreadcrumbFragment_context,
  ContentElementIconFragment,
  ContentStatus,
  FolderType,
  GetMyExams_examSyllabusList,
  GetStudyProgrammeElementIconFragment,
} from "__generated__/types";

export function isElementPublished(data: {
  content: { status: ContentStatus };
}): boolean {
  return data.content.status === ContentStatus.PUBLISHED;
}

export function isPublished(data: { status: ContentStatus }): boolean {
  return data.status == ContentStatus.PUBLISHED;
}

export function isSyllabusForStudent(
  examSyllabi: GetMyExams_examSyllabusList[] | undefined,
  syllabusInContext: ContentInList,
): boolean {
  return !!examSyllabi?.some((e) => e.id === syllabusInContext.value?.id);
}

export interface ContextListItem {
  __typename: string;
}

export function isInSyllabus(
  context: ContentBreadcrumbFragment_context[],
): boolean {
  return context.some((e) => e.__typename === "ExamSyllabus");
}

gql`
  fragment ContentElementIconFragment on ContentElement {
    content {
      ... on Article {
        youtubeVideoId
      }
      ... on Folder {
        type
      }
    }
  }
`;

export function getElementIcon(
  contentElement: ContentElementIconFragment,
): React.ReactNode {
  switch (contentElement.content.__typename) {
    case "Kurssloeyfe":
      return <MedalIcon withBackground />;
    case "MultipleChoice":
      return <QuestionIcon withBackground />;
    case "Article":
      return contentElement.content.youtubeVideoId ? (
        <VideoIcon withBackground />
      ) : (
        <TextIcon withBackground />
      );
    case "Folder":
      return contentElement.content.type === FolderType.GENERIC ? (
        <FolderIcon withBackground />
      ) : (
        <SelfAssessmentIcon withBackground />
      );
    case "StudyProgramme":
      return <BooksIcon withBackground />;
    case "ExamSyllabus":
      return <SyllabusIcon withBackground />;
  }
}

export function getStudyProgrammeElementIcon(
  element: GetStudyProgrammeElementIconFragment,
): React.ReactNode {
  switch (element.content.__typename) {
    case "ExamSyllabus":
      return <SyllabusIcon withBackground />;
    case "Folder":
      return <FolderIcon withBackground />;
    case "Kurssloeyfe":
    case "StudyProgramme":
    case "Article":
    case "MultipleChoice":
      return <SyllabusIcon withBackground />;
  }
}

export const iconMapping = {
  Kurssloeyfe: {
    icon: kurssloeyfeIcon,
  },
  Article: {
    icon: articleIcon,
  },
  Folder: {
    icon: folderIcon,
  },
  MultipleChoice: {
    icon: multiplechoiceIcon,
  },
  ExamSyllabus: {
    icon: syllabusIcon,
  },
  StudyProgramme: {
    icon: studyProgrammeIcon,
  },
  SelfAssessment: {
    icon: selfAssessmentIcon,
  },
  SelfAssessmentsContainer: {
    icon: selfAssessmentsContainerIcon,
  },
};

export function getParentFromContentContext(
  context: ContentBreadcrumbFragment_context[] | null | undefined,
): ContentBreadcrumbFragment_context | null {
  if (context?.length === 1 || !context?.length) {
    return null;
  }

  return context[context.length - 2];
}
